export default "__VITE_ASSET__votHLoTQ__"